import React, { PureComponent } from 'react';

import { Form, Radio, Slider, Button } from 'antd';
import { services } from '@comall-backend-builder/core';
import { language } from '../../../language';
import { cloneDeep, get } from 'lodash';
import { Icon, Row, Col, Input } from 'antd';
import {
    ColorPicker,
    EntryList,
    ConfigFormDecorator,
    FormItemLayout,
    UploadPicture,
} from '../../tools';
import { NavItem } from './nav-item';
import { NavTips } from './nav-tips';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;

const interpolate = services.interpolate;
const MAX_ENTRY_COUNT = 99;
/**
 * 导航组件-配置表单
 */
class ImageNavCom extends PureComponent<any> {
    state = {
        templateId: this.props.value.showStyle || 'imagetext',
    };
    handleClickTemplates = (id: string) => {
        const { form, onChange } = this.props;
        const formValue = form.getFieldsValue();

        this.setState(
            {
                templateId: id,
            },
            () => onChange({ ...formValue, showStyle: id })
        );
    };

    WrapNavItem = (props) => {
        const { value, uploadAction, selector, sourceRoot } = this.props;
        return (
            <NavItem
                {...props}
                sourceRoot={sourceRoot}
                selector={selector}
                uploadAction={uploadAction}
                key={props.index}
                showStyle={value.showStyle}
            />
        );
    };
    onUploadBack = (path: string) => {
        this.change('backPic', path);
    };
    change = (type, val) => {
        let { onChange, value } = this.props;
        let newValue = {
            leftPic: get(value, 'leftPic', null),
            backPic: get(value, 'backPic', null),
            title: get(value, 'title', ''),
            text: get(value, 'text', ''),
            border: get(value, 'border', false),
            linkParams: get(value, 'linkParams', null),
            linkType: get(value, 'linkType', 'none'),
        };
        if (type !== 'linkTypes') {
            newValue[type] = val;
        } else {
            newValue['linkParams'] = val.linkParams;
            newValue['linkType'] = val.linkType;
        }
        onChange({ ...newValue });
    };

    render() {
        const {
            form: { getFieldDecorator },
            linkTypes,
            linkTypeMode,
            sourceRoot,
            value,
            item,
            uploadAction,
        } = this.props;

        console.log('----------nav props:---------' + this.props);
        const formItemLayout = FormItemLayout;
        const templates = [
            {
                id: 'image',
                name: '图文导航',
            },
            {
                id: 'text',
                name: '文字导航',
            },
            {
                id: 'img',
                name: '图片导航',
            },
        ];
        return (
            <Form className="editor-categories-nav">
                <FormItem {...FormItemLayout} label={language.getText('components.Nav.selectType')}>
                    {[
                        getFieldDecorator('showStyle', {}),
                        templates.map((item) => (
                            <Button
                                type={this.state.templateId === item.id ? 'primary' : 'default'}
                                shape="round"
                                style={{ marginRight: '10px' }}
                                key={item.id}
                                onClick={() => this.handleClickTemplates(item.id)}
                            >
                                {item.name}
                            </Button>
                        )),
                    ]}
                </FormItem>
                {/* <FormItem {...formItemLayout} label={language.getText('components.Nav.selectType')}>
                    {getFieldDecorator(
                        'showStyle',{}
                    )(
                        <RadioGroup className="show-style">
                            <Radio value={'image'}>
                                {language.getText('components.Nav.graphic')}
                            </Radio>
                            <Radio value={'text'}>{language.getText('components.Nav.text')}</Radio>
                        </RadioGroup>
                    )}
                </FormItem> */}
                <FormItem {...formItemLayout} label={language.getText('components.Nav.number')}>
                    {getFieldDecorator('count')(
                        <RadioGroup className="nav-num">
                            <Radio value={2}>
                                <span className={'nav-num'}>一行两个</span>
                            </Radio>
                            <Radio value={3}>
                                <span className={'nav-num'}>一行三个</span>
                            </Radio>
                            <Radio value={4}>
                                <span className={'nav-num'}>一行四个</span>
                            </Radio>
                            <Radio value={5}>
                                <span className={'nav-num'}>一行五个</span>
                            </Radio>
                        </RadioGroup>
                    )}
                </FormItem>
                <FormItem {...formItemLayout} label={language.getText('components.Nav.color')}>
                    {getFieldDecorator('textColor', {})(<ColorPicker />)}
                </FormItem>
                {/* 背景颜色 */}
                <FormItem {...formItemLayout} label="背景颜色">
                    {getFieldDecorator('backColor', {})(<ColorPicker />)}
                </FormItem>
                {/* 背景图片 */}
                <FormItem {...formItemLayout} label={'背景图片'}>
                    <Row
                        className="entry-item"
                        style={{ backgroundColor: '#FFFFFF', border: 'none' }}
                    >
                        <Col className="entry-item-image" span={10}>
                            <UploadPicture
                                value={get(value, 'backPic', '')}
                                sourceRoot={sourceRoot}
                                onChange={this.onUploadBack}
                                uploadAction={uploadAction}
                            />
                        </Col>
                    </Row>
                </FormItem>
                <FormItem {...formItemLayout} label={language.getText('components.Nav.pageMargin')}>
                    {getFieldDecorator('margin')(<Slider max={48} min={0} />)}
                </FormItem>
                <FormItem>
                    {getFieldDecorator('entry', {
                        initialValue: [],
                    })(
                        <EntryList
                            linkTypes={linkTypes}
                            linkTypeMode={linkTypeMode}
                            maxCount={MAX_ENTRY_COUNT}
                            renderItem={this.WrapNavItem}
                            renderTips={NavTips}
                        />
                    )}
                </FormItem>
                <p className="entry-tip">
                    {interpolate(language.getText('components.ImageAd.tips'), {
                        max: 99,
                    })}
                </p>
            </Form>
        );
    }
}

export const ImageNav = ConfigFormDecorator(ImageNavCom);
